export enum FrontOrigin {
    USER = 'USER',
    ADMIN = 'ADMIN',
    MOBILE = 'MOBILE'
}
